<template>
  <div class="container-finance">
    <van-nav-bar
      id='van-nav-bar'
      title="财务月报"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="date-box">
      <div class="days">
        <button @click="chooseMonth">
        {{ searchMonthShow }}
        </button>
      </div>
      <div class="title-box">
        <div class="title">当前余额:</div>
        <div class="content">{{remainAmount}}</div>
      </div>
      <div class="button-box">
        <button @click="txBtnTap">提现</button>
      </div>
    </div>
    <div class="data-wrapper">
        <FinanceItem 
          v-for="item in list"
          :key="item.id"
          :date = "item.settleDayStr"
          :incomeOff = "item.incomeOff"
          :paymentOff = "item.paymentOff"
        />
    </div>
    <van-popup v-model="showTX" position="bottom" class="pop-layer">
      <van-form @submit="onTX">
        <div class="title">提现说明：</div>
        <div class="notice">每日可提现<span class="red">{{txCount}}</span>次，提现金额不超过<span class="red">{{txAmount}}</span>元。处理时间不超过24小时。</div>
        <div class="info"><span class="title">普通提现：</span><br/>手续费<span class="red">0%</span>，到账时间为T+1日15:00以前<br/>计算例：普通提现100元，实际到账100元</div>
        <div class="info"><span class="title">快速提现：</span><br/>申请时间段：8:00 - 20:00<br/>手续费<span class="red">0.6%</span>，提交申请后2小时到账<br/>计算例：快速提现100元，实际到账99.4元</div>
        <van-field
          v-model="txPrice"
          class="van1"
          type="number"
          name="txPrice"
          label="提现金额"
          clearable
          :border="true"
          placeholder="输入金额"
        />
        <van-checkbox v-if="drawType==1" class="check-box1" v-model="checked">快速提现</van-checkbox>
        <div style="margin: 16px">
          <van-button round block :disabled="txLoading" :loading="txLoading" type="info" native-type="submit" loading-text="加载中...">
            提交
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <template v-if="showMonthPicker">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        class="monthPicker"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm='pickerConfirm'
        @cancel='pickerCancel'
      />
    </template>
  </div>
</template>
<script>
import { getMonthFinanceList ,indexData,withDraw, getDrawInfo} from "../../utils/api";
import FinanceItem from "@/components/FinanceItem.vue";
import { app } from "../../utils/app";
import { NavBar, Uploader, Popup, Form, Field, Button, DatetimePicker,Toast,Checkbox,Dialog} from "vant";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(NavBar);
Vue.use(Vuex);
Vue.use(Uploader);
Vue.use(Popup);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(DatetimePicker);
Vue.use(Toast)
Vue.use(Checkbox)
Vue.use(Dialog);


// @ is an alias to /src

export default {
  name: "ShopData",
  components: {FinanceItem},
  data() {
    return {
      list: "",
      token:'',//用户token
      shopToken: "",//店铺token
      searchMonth: "",
      searchMonthShow:'',
      txPrice: "",
      txCount:'',
      txAmount:'',
      txPercent:'0%',
      showTX: false,
      nowPrice:'',
      remainAmount:'',
      showMonthPicker:false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      rate:'', //提现手续费
      drawType:0,// 默认普通提现
      checked:false, //快速提现选中状态
      txLoading:false,
    };
  },
  created() {
    let token = app.storage.get("token");
    this.token = token
    let shopToken = app.storage.get("shopToken");
    this.shopToken = shopToken;
    // console.log("shopToken:", this.shopToken);
    this.searchMonthShow = this.getNowMonth(0)
    this.searchMonth = this.getNowMonth()
    this.getMonthFinanceList();
  },
  mounted() {
    this.indexData()
    this.getDrawInfo()
    let rate = app.storage.get("shopInfo").rate;
    this.rate = rate
  },
  watch: {},
  methods: {
    //获取月度财务列表
    async getMonthFinanceList() {
      let params = {
        searchMonth: this.searchMonth,
        usertoken: this.shopToken,
      };
      let res = await getMonthFinanceList(params);
      this.list = res.data.balanceDayList
    },
    async indexData(){
      let res = await indexData({
        usertoken: this.shopToken,
      });
      this.remainAmount = res.data.remainAmount;
    },
    async getDrawInfo(){
      let params = {
        usertoken: this.shopToken
      }
      let res = await getDrawInfo(params);
      if (res.data.code == 0) {
        this.txCount = res.data.daycnt
        this.txAmount = res.data.daysum
        this.drawType = res.data.drawFlag
      }
    },
    onClickLeft() {
      this.$router.back();
    },
    txBtnTap() {
      this.showTX = true;
    },
    async onTX(values) {
      console.log(values);
      let val = parseFloat(values.txPrice).toFixed(2)
      this.txPrice = val
      if (this.txPrice > this.remainAmount) {
        Toast({
          message:'已超出余额'
        })
        return
      }
      this.txLoading = true
      let params = {
        fee:val,
        token:this.token,
        usertoken:this.shopToken,
        drawType:this.checked?1:0
      }
      let res = await withDraw(params)
      if (res.data.code != 200) {
        console.log(res)
        Dialog.alert({
          message: res.data.msg,
        }).then(() => {
          // on close
          this.showTX = false
        });
        this.txLoading = false
      }else{
        this.txLoading = false
        Dialog.alert({
          message: '申请成功',
        }).then(() => {
          // on close
          this.indexData()
          this.showTX = false
        });
        //刷新页面数据
        // setTimeout(()=>{
        //   this.indexData()
        // },1000)
      }
    },
    getNowMonth(type){
      let d= new Date()
      let year= d.getFullYear()
      let month= d.getMonth()<9?`0${d.getMonth()+1}`:d.getMonth()+1
      if (type==0) {
        return `${year}年${month}月`
      }else{
        return `${year}${month}`
      }
    },
    chooseMonth(){
      this.showMonthPicker = true
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    //查询月份
    pickerConfirm(date){
      let year= date.getFullYear()
      let month= date.getMonth()>8?`${date.getMonth()+ 1}`:`0${date.getMonth()+1}`
      this.searchMonth= `${year}${month}`
      this.searchMonthShow= `${year}年${month}月`
      this.showMonthPicker= false
      this.getMonthFinanceList()
    },
    pickerCancel(){
      this.showMonthPicker = false
    }
  },
};
</script>
<style lang="scss">
.container-finance {
  .data-wrapper button {
    width: 12.5rem;
    height: 3.125rem;
    margin: 0.625rem;
  }
  .pop-layer {
    min-height: 200px;
    box-sizing: border-box;
    padding: 20px;
    .notice{
      font-size: 0.8rem;
      text-align: left;
      color: #9c9c9c;
      padding: 10px;
      .red{
        color: red;
      }
    }
    .info{
      font-size: 0.8rem;
      text-align: left;
      color: #9c9c9c;
      padding: 0 10px;
      .title{
        color: #6b6b6b;
      }
      .red{
        color: red;
      }
    }
    .van1{
      margin-top: 10px;
    }
    .check-box1{
      padding-left: 10px;
      margin-top: 10px;
    }
  }
  .date-box{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    .days{
      min-width: 20%;
    }
    .title-box{
      min-width: 20%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .9rem;
      font-weight: bold;
      text-align: center;
    }
    .button-box{
      min-width: 20%;
      text-align: right;
    }
  }
  .monthPicker{
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}
</style>
